<template>
  <div class="ranking-container">
    <div class="ranking-title">{{topic}}</div>
    <div class="ranking-products">
      <router-link class="ranking-product" v-for="(product,index) in products" :key="index" :to="'/product/' + product.productId" @click.native="flushCom">
        <img :src="'http://image.teamcorp.cn/wo_de/product/'+product.image" alt="">
        <div class="ranking-product-name">{{product.name}}</div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ['topic', 'products'],
  methods: {
    flushCom () {
      this.$router.go(0)
    }
  }
}
</script>

<style scoped>
.ranking-container {
  width: 100%;
  margin: 22px 0 0 0;
  background: #ffffff;
}
.ranking-title {
  text-align: center;
  font-size: 22px;
  color: #ffffff;
  background:#018FD7;
  height:50px;
  line-height: 50px;
  margin: 0 0 5px 0;
}
.ranking-product img {
  width: 220px;
  height: 165px;
  overflow: hidden;
}
.ranking-product-name {
  text-align: center;
  padding: 8px 0;
}
</style>



// WEBPACK FOOTER //
// src/widgets/product/Ranking.vue